import React from 'react';
import { motion } from 'framer-motion';
export function SocialProofSection() {
  const projects = [{
    name: 'Clínica Dental',
    color: 'from-blue-500/20 to-cyan-500/20',
    border: 'border-blue-500/30'
  }, {
    name: 'Despacho Contable',
    color: 'from-emerald-500/20 to-teal-500/20',
    border: 'border-emerald-500/30'
  }, {
    name: 'Taller Mecánico',
    color: 'from-orange-500/20 to-red-500/20',
    border: 'border-orange-500/30'
  }];
  return <section className="py-24 bg-[#0a1120] relative border-t border-nova-navy-light/20" data-id="element-240">
      <div className="container mx-auto px-4 md:px-6" data-id="element-241">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-242">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight" data-id="element-243">
            Vea cómo estamos ayudando a otros negocios en México a verse
            profesionales.
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-244">
          {projects.map((project, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group" data-id="element-245">
              {/* Browser Window Mockup */}
              <div className={`rounded-xl border ${project.border} bg-nova-navy-dark overflow-hidden shadow-xl transition-transform duration-300 group-hover:-translate-y-2`} data-id="element-246">
                {/* Browser Header */}
                <div className="bg-nova-navy-light/30 px-4 py-3 flex items-center gap-2 border-b border-nova-navy-light/30" data-id="element-247">
                  <div className="flex gap-1.5" data-id="element-248">
                    <div className="w-3 h-3 rounded-full bg-red-500/80" data-id="element-249" />
                    <div className="w-3 h-3 rounded-full bg-yellow-500/80" data-id="element-250" />
                    <div className="w-3 h-3 rounded-full bg-green-500/80" data-id="element-251" />
                  </div>
                  <div className="mx-auto bg-nova-navy-dark/50 rounded-md px-3 py-1 text-xs text-gray-500 w-1/2 text-center truncate" data-id="element-252">
                    {project.name.toLowerCase().replace(' ', '')}.com.mx
                  </div>
                </div>

                {/* Browser Content (Placeholder) */}
                <div className={`aspect-[4/3] bg-gradient-to-br ${project.color} p-6 flex flex-col relative overflow-hidden`} data-id="element-253">
                  {/* Abstract UI Elements */}
                  <div className="w-3/4 h-6 bg-white/10 rounded mb-4" data-id="element-254" />
                  <div className="w-1/2 h-4 bg-white/10 rounded mb-8" data-id="element-255" />

                  <div className="grid grid-cols-2 gap-4 mb-auto" data-id="element-256">
                    <div className="h-20 bg-white/5 rounded-lg" data-id="element-257" />
                    <div className="h-20 bg-white/5 rounded-lg" data-id="element-258" />
                  </div>

                  <div className="w-full h-10 bg-nova-gold/80 rounded-lg mt-4 flex items-center justify-center" data-id="element-259">
                    <div className="w-1/3 h-3 bg-nova-navy-dark/50 rounded" data-id="element-260" />
                  </div>

                  {/* Overlay on hover */}
                  <div className="absolute inset-0 bg-nova-navy-dark/80 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center backdrop-blur-sm" data-id="element-261">
                    <span className="text-white font-bold border border-white/30 px-4 py-2 rounded-full text-sm" data-id="element-262">
                      Ver Caso de Éxito
                    </span>
                  </div>
                </div>
              </div>
              <p className="text-center mt-4 font-medium text-gray-300" data-id="element-263">
                {project.name}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}